import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  es: {
    nav: {
      home: 'Inicio',
      about: 'Sobre Tomás',
      profile: 'Perfil',
      stats: 'Estadísticas',
      career: 'Trayectoria',
      videos: 'Videos',
      gallery: 'Galería',
      contact: 'Contacto'
    },
    hero: {
      position: 'Extremo | Universidad de Concepción (cedido por Fortaleza)',
      description: 'Extremo chileno de alto potencial, formado en Cobreloa y desarrollado en Fortaleza (Brasil). Actualmente cedido a Universidad de Concepción desde agosto de 2026 con opción de compra.',
      description2: 'Jugador ambidiestro, vertical y explosivo, con capacidad para marcar diferencias en el uno contra uno y en transición ofensiva.',
      cta: 'Conocer más',
      scroll: 'Desliza para explorar',
      statsTitle: 'Stats destacadas (2025)',
      statsMatches: 'partidos',
      statsGoals: 'goles',
      statsAssists: 'asistencias',
      statsSpeed: 'km/h velocidad máxima'
    },
    about: {
      title: 'Sobre Tomás',
      subtitle: 'Perfil del jugador',
      bio1: 'Tomás Roco Latorre (03/05/2006) es un extremo chileno que destaca por su velocidad, agresividad ofensiva y capacidad de desequilibrio.',
      bio2: 'Con formación en Cobreloa, dio el salto al fútbol profesional debutando en Primera División con solo 17 años, mostrando personalidad y condiciones para competir al máximo nivel.',
      bio3: 'Tras su desarrollo en Fortaleza Esporte Clube (Brasil), actualmente se encuentra cedido en Universidad de Concepción (Chile) desde agosto de 2026 con opción de compra, donde busca consolidarse en Primera División.',
      bio4: 'Su perfil responde al extremo moderno: rápido, vertical, ambidiestro y con impacto directo en el juego ofensivo.'
    },
    playerProfile: {
      title: 'Perfil Futbolístico',
      subtitle: 'Jugador que busca constantemente el desequilibrio y acelerar el juego ofensivo.',
      attributes: [
        'Extremo ambidiestro',
        'Muy veloz y vertical',
        'Especialista en el 1 vs 1',
        'Capacidad para atacar espacios',
        'Generador de ocasiones',
        'Alto ritmo en transición',
        'Intensidad sin balón'
      ]
    },
    stats: {
      title: 'Estadísticas',
      season: 'Temporada 2025 – Fortaleza U20',
      matches: 'Partidos',
      starts: 'Titularidades',
      minutes: 'Minutos',
      goals: 'Goles',
      assists: 'Asistencias',
      offensive: 'Rendimiento ofensivo',
      dribbles: 'Regates exitosos',
      dribblesValue: '1.5 por partido (79%)',
      keyPasses: 'Pases clave',
      keyPassesValue: '0.9 por partido',
      duels: 'Duelos ofensivos ganados',
      duelsValue: '48%',
      physical: 'Perfil físico',
      maxSpeed: 'Velocidad máxima',
      maxSpeedValue: '34.0 km/h',
      distance: 'Distancia recorrida',
      distanceValue: '8.7 km por partido',
      defensive: 'Sin balón',
      recoveries: 'Recuperaciones',
      recoveriesValue: '3.9 por partido'
    },
    career: {
      title: 'Trayectoria',
      subtitle: 'Clubes y Experiencia',
      cobreloa: {
        name: 'Cobreloa',
        country: 'Chile',
        description: 'Formación y desarrollo. Debut en Primera División con 17 años.'
      },
      fortaleza: {
        name: 'Fortaleza EC',
        country: 'Brasil',
        description: 'Desarrollo internacional en un club de Serie A. Participación en competiciones U20 de alto nivel.'
      },
      udec: {
        name: 'Universidad de Concepción',
        country: 'Chile',
        description: 'Cesión desde agosto de 2026 con opción de compra. Competencia en Primera División chilena.'
      }
    },
    projection: {
      title: 'Proyección',
      text: 'Tomás Roco representa el perfil de extremo moderno en desarrollo: velocidad, ambidestreza y mentalidad competitiva. Su evolución en el fútbol brasileño y su rendimiento en etapas tempranas lo posicionan como un jugador con proyección internacional y margen de crecimiento hacia el fútbol europeo.'
    },
    videos: {
      title: 'Videos',
      subtitle: 'Momentos destacados en acción',
      largo: 'Largo Fortaleza',
      corto: 'Corto Fortaleza',
      debut: 'Debut Fortaleza'
    },
    gallery: {
      title: 'Galería',
      subtitle: 'Momentos destacados'
    },
    contact: {
      title: 'Contacto',
      subtitle: 'Conecta conmigo',
      agentTitle: 'Representación Profesional',
      agentName: 'Agente FIFA',
      name: 'Edgar Merino Vidangossy',
      agencyName: 'Ikons Agency',
      form: {
        name: 'Nombre',
        email: 'Correo Electrónico',
        club: 'Club / Organización',
        message: 'Mensaje',
        send: 'Enviar Mensaje',
        success: 'Mensaje enviado exitosamente',
        error: 'Error al enviar el mensaje'
      },
      social: {
        player: 'Jugador',
        agent: 'Agente',
        agency: 'Agencia'
      }
    },
    footer: {
      rights: 'Todos los derechos reservados',
      social: 'Sígueme en redes'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About Tomás',
      profile: 'Profile',
      stats: 'Statistics',
      career: 'Career',
      videos: 'Videos',
      gallery: 'Gallery',
      contact: 'Contact'
    },
    hero: {
      position: 'Winger | Universidad de Concepción (on loan from Fortaleza)',
      description: 'Chilean winger with high potential, formed at Cobreloa and developed at Fortaleza (Brazil). Currently on loan at Universidad de Concepción since August 2026 with purchase option.',
      description2: 'Two-footed, vertical and explosive player, with the ability to make a difference in one-on-one situations and in offensive transition.',
      cta: 'Learn More',
      scroll: 'Scroll to explore',
      statsTitle: 'Key Stats (2025)',
      statsMatches: 'matches',
      statsGoals: 'goals',
      statsAssists: 'assists',
      statsSpeed: 'km/h top speed'
    },
    about: {
      title: 'About Tomás',
      subtitle: 'Player Profile',
      bio1: 'Tomás Roco Latorre (05/03/2006) is a Chilean winger who stands out for his speed, offensive aggression and ability to create imbalance.',
      bio2: 'Trained at Cobreloa, he made the jump to professional football making his First Division debut at just 17 years old, showing personality and conditions to compete at the highest level.',
      bio3: 'After his development at Fortaleza Esporte Clube (Brazil), he is currently on loan at Universidad de Concepción (Chile) since August 2026 with purchase option, where he seeks to establish himself in the First Division.',
      bio4: 'His profile responds to the modern winger: fast, vertical, two-footed and with direct impact on offensive play.'
    },
    playerProfile: {
      title: 'Football Profile',
      subtitle: 'Player who constantly seeks to create imbalance and accelerate offensive play.',
      attributes: [
        'Two-footed winger',
        'Very fast and vertical',
        'Specialist in 1 vs 1',
        'Ability to attack spaces',
        'Chance creator',
        'High transition pace',
        'Intensity without the ball'
      ]
    },
    stats: {
      title: 'Statistics',
      season: '2025 Season – Fortaleza U20',
      matches: 'Matches',
      starts: 'Starts',
      minutes: 'Minutes',
      goals: 'Goals',
      assists: 'Assists',
      offensive: 'Offensive Performance',
      dribbles: 'Successful dribbles',
      dribblesValue: '1.5 per match (79%)',
      keyPasses: 'Key passes',
      keyPassesValue: '0.9 per match',
      duels: 'Offensive duels won',
      duelsValue: '48%',
      physical: 'Physical Profile',
      maxSpeed: 'Top speed',
      maxSpeedValue: '34.0 km/h',
      distance: 'Distance covered',
      distanceValue: '8.7 km per match',
      defensive: 'Without the ball',
      recoveries: 'Recoveries',
      recoveriesValue: '3.9 per match'
    },
    career: {
      title: 'Career',
      subtitle: 'Clubs and Experience',
      cobreloa: {
        name: 'Cobreloa',
        country: 'Chile',
        description: 'Formation and development. First Division debut at 17 years old.'
      },
      fortaleza: {
        name: 'Fortaleza EC',
        country: 'Brazil',
        description: 'International development at a Serie A club. Participation in high-level U20 competitions.'
      },
      udec: {
        name: 'Universidad de Concepción',
        country: 'Chile',
        description: 'On loan since August 2026 with purchase option. Competition in Chilean First Division.'
      }
    },
    projection: {
      title: 'Projection',
      text: 'Tomás Roco represents the profile of a modern winger in development: speed, two-footedness and competitive mentality. His evolution in Brazilian football and his performance in early stages position him as a player with international projection and growth potential towards European football.'
    },
    videos: {
      title: 'Videos',
      subtitle: 'Highlights in action',
      largo: 'Full Fortaleza',
      corto: 'Short Fortaleza',
      debut: 'Fortaleza Debut'
    },
    gallery: {
      title: 'Gallery',
      subtitle: 'Highlights'
    },
    contact: {
      title: 'Contact',
      subtitle: 'Get in Touch',
      agentTitle: 'Professional Representation',
      agentName: 'FIFA Agent',
      name: 'Edgar Merino Vidangossy',
      agencyName: 'Ikons Agency',
      form: {
        name: 'Name',
        email: 'Email',
        club: 'Club / Organization',
        message: 'Message',
        send: 'Send Message',
        success: 'Message sent successfully',
        error: 'Error sending message'
      },
      social: {
        player: 'Player',
        agent: 'Agent',
        agency: 'Agency'
      }
    },
    footer: {
      rights: 'All rights reserved',
      social: 'Follow me'
    }
  },
  pt: {
    nav: {
      home: 'Início',
      about: 'Sobre Tomás',
      profile: 'Perfil',
      stats: 'Estatísticas',
      career: 'Trajetória',
      videos: 'Vídeos',
      gallery: 'Galeria',
      contact: 'Contato'
    },
    hero: {
      position: 'Ponta | Universidad de Concepción (emprestado pelo Fortaleza)',
      description: 'Ponta chileno de alto potencial, formado no Cobreloa e desenvolvido no Fortaleza (Brasil). Atualmente emprestado à Universidad de Concepción desde agosto de 2026 com opção de compra.',
      description2: 'Jogador ambidestro, vertical e explosivo, com capacidade para fazer a diferença no um contra um e na transição ofensiva.',
      cta: 'Saiba Mais',
      scroll: 'Role para explorar',
      statsTitle: 'Stats em destaque (2025)',
      statsMatches: 'partidas',
      statsGoals: 'gols',
      statsAssists: 'assistências',
      statsSpeed: 'km/h velocidade máxima'
    },
    about: {
      title: 'Sobre Tomás',
      subtitle: 'Perfil do jogador',
      bio1: 'Tomás Roco Latorre (03/05/2006) é um ponta chileno que se destaca pela velocidade, agressividade ofensiva e capacidade de desequilíbrio.',
      bio2: 'Com formação no Cobreloa, deu o salto para o futebol profissional estreando na Primeira Divisão com apenas 17 anos, mostrando personalidade e condições para competir no mais alto nível.',
      bio3: 'Após seu desenvolvimento no Fortaleza Esporte Clube (Brasil), atualmente está emprestado à Universidad de Concepción (Chile) desde agosto de 2026 com opção de compra, onde busca se consolidar na Primeira Divisão.',
      bio4: 'Seu perfil responde ao ponta moderno: rápido, vertical, ambidestro e com impacto direto no jogo ofensivo.'
    },
    playerProfile: {
      title: 'Perfil Futebolístico',
      subtitle: 'Jogador que busca constantemente o desequilíbrio e acelerar o jogo ofensivo.',
      attributes: [
        'Ponta ambidestro',
        'Muito veloz e vertical',
        'Especialista no 1 vs 1',
        'Capacidade para atacar espaços',
        'Gerador de oportunidades',
        'Alto ritmo em transição',
        'Intensidade sem bola'
      ]
    },
    stats: {
      title: 'Estatísticas',
      season: 'Temporada 2025 – Fortaleza U20',
      matches: 'Partidas',
      starts: 'Titularidades',
      minutes: 'Minutos',
      goals: 'Gols',
      assists: 'Assistências',
      offensive: 'Desempenho ofensivo',
      dribbles: 'Dribles bem-sucedidos',
      dribblesValue: '1.5 por partida (79%)',
      keyPasses: 'Passes-chave',
      keyPassesValue: '0.9 por partida',
      duels: 'Duelos ofensivos ganhos',
      duelsValue: '48%',
      physical: 'Perfil físico',
      maxSpeed: 'Velocidade máxima',
      maxSpeedValue: '34.0 km/h',
      distance: 'Distância percorrida',
      distanceValue: '8.7 km por partida',
      defensive: 'Sem bola',
      recoveries: 'Recuperações',
      recoveriesValue: '3.9 por partida'
    },
    career: {
      title: 'Trajetória',
      subtitle: 'Clubes e Experiência',
      cobreloa: {
        name: 'Cobreloa',
        country: 'Chile',
        description: 'Formação e desenvolvimento. Estreia na Primeira Divisão aos 17 anos.'
      },
      fortaleza: {
        name: 'Fortaleza EC',
        country: 'Brasil',
        description: 'Desenvolvimento internacional em um clube da Série A. Participação em competições U20 de alto nível.'
      },
      udec: {
        name: 'Universidad de Concepción',
        country: 'Chile',
        description: 'Emprestado desde agosto de 2026 com opção de compra. Competição na Primeira Divisão chilena.'
      }
    },
    projection: {
      title: 'Projeção',
      text: 'Tomás Roco representa o perfil de ponta moderno em desenvolvimento: velocidade, ambidestria e mentalidade competitiva. Sua evolução no futebol brasileiro e seu desempenho em etapas iniciais o posicionam como um jogador com projeção internacional e margem de crescimento rumo ao futebol europeu.'
    },
    videos: {
      title: 'Vídeos',
      subtitle: 'Momentos destacados em ação',
      largo: 'Completo Fortaleza',
      corto: 'Curto Fortaleza',
      debut: 'Estreia Fortaleza'
    },
    gallery: {
      title: 'Galeria',
      subtitle: 'Momentos destacados'
    },
    contact: {
      title: 'Contato',
      subtitle: 'Entre em Contato',
      agentTitle: 'Representação Profissional',
      agentName: 'Agente FIFA',
      name: 'Edgar Merino Vidangossy',
      agencyName: 'Ikons Agency',
      form: {
        name: 'Nome',
        email: 'E-mail',
        club: 'Clube / Organização',
        message: 'Mensagem',
        send: 'Enviar Mensagem',
        success: 'Mensagem enviada com sucesso',
        error: 'Erro ao enviar mensagem'
      },
      social: {
        player: 'Jogador',
        agent: 'Agente',
        agency: 'Agência'
      }
    },
    footer: {
      rights: 'Todos os direitos reservados',
      social: 'Siga-me'
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('es');

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
